<template>
  <b-datepicker v-bind="$attrs" icon="calendar" v-on="$listeners" />
</template>

<script>
export default {}
</script>
